import React, { useState, useEffect } from 'react';
import {
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import RouteIdDrilldownTableRow from './RouteIdDrilldownTableRow';
import Loader from '../../common/Loader';

const RouteIdDrilldown = (props) => {
  const [recentMessages, setRecentMessages] = useState([]);

  useEffect(() => {
    getRouteIdDrilldown();
  }, [props.selectedRouteId]);

  const getRouteIdDrilldown = async () => {
    let recentMessages = await props.getRouteIdDrilldown(props.selectedRouteId);
    setRecentMessages(recentMessages);
  };

  const generateContent = () => {
    return (
      <div className="visible-desktop">
        {generateBackButton()}
        <Typography variant="h5">{props.selectedRouteId}</Typography>
        {generateTable()}
      </div>
    );
  };

  const generateTable = () => {
    if (recentMessages && recentMessages.length > 0) {
      return (
        <TableContainer>
          <Table width="100%">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Link</TableCell>
                <TableCell>TO</TableCell>
                <TableCell>FROM</TableCell>
                <TableCell>SMSID</TableCell>
                <TableCell>Result (ms)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{generateTableBody()}</TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return <Loader />;
    }
  };

  /*
   Generates the body of the Table/List to display all Provider data
 */
  const generateTableBody = () => {
    let rows = [];
    for (let i = 0; i < recentMessages.length; i++) {
      rows.push(
        <RouteIdDrilldownTableRow
          key={recentMessages[i].routeId}
          id={recentMessages[i].routeId}
          date={recentMessages[i].date}
          routeId={recentMessages[i].routeId}
          destTn={recentMessages[i].destTn}
          originTn={recentMessages[i].originTn}
          smsId={recentMessages[i].smsId}
          totalMessageProcessing={recentMessages[i].totalMessageProcessing}
        />
      );
    }
    return rows;
  };

  /**
   * Generates back button to go back to the Stats page.
   * @returns button component (as a p tag)
   */
  const generateBackButton = () => {
    return (
      <Box className="backLink" onClick={() => props.backToMuxIdDrilldown()}>
        <IconButton>
          <ArrowBackIcon />
        </IconButton>
        <Typography>Back</Typography>
      </Box>
    );
  };

  return generateContent();
};

export default RouteIdDrilldown;
